module.exports = __webpack_public_path__ + "static/media/snapchat.d339a950.png";